import api from './axios.js';

export const aiAgentApi = {
  getConfig: () => api.get('/ai-agent/config'),
  updateConfig: (data) => api.put('/ai-agent/config', data),
  ask: (data) => api.post('/ai-agent/ask', data),
  runs: () => api.get('/ai-agent/runs'),
};
